const getContactLensProductFeatures = (variantTypeDetails)=>{
    const { hasBetterAllRoundVision , hasBetterHydration , hasEnhancedSoftness , hasIncreasedBreathability , hasLessFatigue , hasUvProtection ,  } = variantTypeDetails;
    const productFeatures = [];
    if (!!hasBetterAllRoundVision) {
        productFeatures.push({
            type: 'basics',
            iconName: 'basics',
            labelKey: 'products.contactLenses.features.basics'
        });
    }
    if (!!hasBetterHydration) {
        productFeatures.push({
            type: 'hydration',
            iconName: 'hydration',
            labelKey: 'products.contactLenses.features.hydration'
        });
    }
    if (!!hasEnhancedSoftness) {
        productFeatures.push({
            type: 'softness',
            iconName: 'softness',
            labelKey: 'products.contactLenses.features.softness'
        });
    }
    if (!!hasIncreasedBreathability) {
        productFeatures.push({
            type: 'breathability',
            iconName: 'breathability',
            labelKey: 'products.contactLenses.features.breathability'
        });
    }
    if (!!hasLessFatigue) {
        productFeatures.push({
            type: 'fatigue',
            iconName: 'fatigue',
            labelKey: 'products.contactLenses.features.eyeFatigue'
        });
    }
    if (!!hasUvProtection) {
        productFeatures.push({
            type: 'uv',
            iconName: 'uv',
            labelKey: 'products.contactLenses.features.uv'
        });
    }
    return productFeatures;
};

export { getContactLensProductFeatures };
//# sourceMappingURL=get-contact-lens-product-features.js.map
